import { useEffect, useRef, useState } from 'react';
import type { ChartShot } from './chart-screenshot';

export function ChartComparison({ before, after, onClose }: { before: ChartShot; after: ChartShot; onClose: () => void }) {
  const dialog = useRef<HTMLDialogElement>(null);
  const opener = useRef<HTMLElement | null>(document.activeElement as HTMLElement | null);
  const [urls, setUrls] = useState<[string, string] | null>(null);
  const [position, setPosition] = useState(50);
  const [view, setView] = useState<'slide' | 'side'>('slide');
  useEffect(() => {
    const next: [string, string] = [URL.createObjectURL(before.blob), URL.createObjectURL(after.blob)];
    setUrls(next);
    return () => next.forEach(url => URL.revokeObjectURL(url));
  }, [before.blob, after.blob]);
  useEffect(() => {
    const element = dialog.current;
    const previous = document.body.style.overflow;
    element?.showModal();
    document.body.style.overflow = 'hidden';
    return () => { element?.close(); document.body.style.overflow = previous; opener.current?.focus({ preventScroll: true }); };
  }, []);
  return <dialog ref={dialog} className="zp-comparison" aria-labelledby="comparison-title" onCancel={event => { event.preventDefault(); onClose(); }}>
    <header><div><span className="zp-section-kicker">CHART REVIEW</span><h2 id="comparison-title">Before / After</h2></div><button aria-label="Tutup perbandingan" onClick={onClose}>×</button></header>
    <div className="zp-compare-tools"><button aria-pressed={view === 'slide'} onClick={() => setView('slide')}>Slider</button><button aria-pressed={view === 'side'} onClick={() => setView('side')}>Sebelah-menyebelah</button><span>{before.symbol} · {before.timeframe === 'D1' ? 'Daily' : before.timeframe}</span></div>
    {urls && (view === 'slide' ? <>
      <div className="zp-comparison-stage">
        <img src={urls[1]} alt="Chart After" />
        <div className="zp-comparison-overlay" style={{ clipPath: 'inset(0 ' + (100 - position) + '% 0 0)' }}><img src={urls[0]} alt="Chart Before" /></div>
        <div className="zp-comparison-labels"><span>01 / BEFORE</span><span>02 / AFTER</span></div>
        <div className="zp-comparison-divider" style={{ left: position + '%' }}><span aria-hidden="true">↔</span></div>
      </div>
      <label className="zp-comparison-range">Before<input aria-label="Pembahagi Before dan After" type="range" min="0" max="100" value={position} onChange={event => setPosition(Number(event.target.value))} /><span>After</span><output>{position}%</output></label>
    </> : <div className="zp-comparison-side">{[before, after].map((shot, index) => <figure key={shot.stage}><figcaption>{index ? '02 / AFTER' : '01 / BEFORE'} · {new Date(shot.capturedAt).toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}</figcaption><img src={urls[index]} alt={'Chart ' + shot.stage} /></figure>)}</div>)}
    <p>Tarik slider atau gunakan kekunci anak panah. Gambar dibandingkan mengikut paparan ketika diambil; skala harga mungkin berbeza.</p>
  </dialog>;
}

